module.exports = __webpack_public_path__ + "media/images/about-1-a4e0158d71884e36b08f06314b85db46.jpg";